@if (showBanner()) {
  <div class="environment-banner" [ngClass]="$safeNavigationMigration(config?.style)">
    <div class="banner-content">
      <div class="banner-text">
        <div class="banner-message">{{ config?.message }}</div>
        @if (config?.subMessage) {
          <div class="banner-submessage">{{ config?.subMessage }}</div>
        }
      </div>
      @if (config?.dismissible) {
        <button 
          class="banner-dismiss" 
          (click)="dismiss()"
          aria-label="Dismiss banner">
          ×
        </button>
      }
    </div>
  </div>
}
